import e from "./Button.module.js";
import "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region lib/components/Button/Button.tsx
function r({ color: r = "primary", size: i = "sm", shape: a = "rounded-corners", noBorder: o = !1, loading: s = !1, disabled: c = !1, iconStart: l, iconEnd: u, label: d, children: f, className: p, ...m }) {
	let h = [
		e["button-defaults"],
		e[`color-${r}`],
		e[`size-${i}`],
		e[`shape-${a}`],
		o && e["no-border"]
	];
	return p && h.push(p), /* @__PURE__ */ t("button", {
		className: h.join(" "),
		type: "button",
		disabled: c || s,
		...m,
		children: /* @__PURE__ */ n("div", {
			className: e["button-content"],
			children: [
				l,
				d,
				" ",
				f,
				u
			]
		})
	});
}
//#endregion
export { r as Button };
